import React, { useEffect, useState, useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import CustomerFilterModel from "../model/CustomerFilterModel";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Checkbox,
  Grid,
  Input,
  InputAdornment,
  ListItemText,
  Stack,
  Button,
  FormControlLabel,
  Select,
  CircularProgress,
  PaginationItem,
  TableSortLabel,
  Icon,
  Autocomplete,
  TextField,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  GET_ALL_BILLING_FILTER_URL,
  CREATE_UPDATE_BILLING_STATEMENT_URL,
  GET_ALL_PROJECT_FILTER_URL,
  GET_DASHBOARD_FILTER_BROKER_LIST,
  GET_BROKER_BILLING_URL,
} from "../../constants/ApiRoute";
import {
  authHeader,
  getLogUserId,
  getLogUserRole,
} from "../comman/MainFunction";
import API from "../comman/API";

import Pagination from "@mui/material/Pagination";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
// import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import { CUSTOMER_HISTORY, ADD_CUSTOMER } from "../../constants/RoutePath";
import UserClearFilter from "../model/UserClearFilter";
import CustomPageLoading from "../comman/CustomPageLoading";
import Navbar from "../comman/Navbar";
import CreateBillingConfirm from "./CreateBillingConfirm";
import BillingStatementMenu from "../comman/BillingStatementMenu";
import {
  getAllCustomersList,
  getAllProjectsList,
  getPerDiemList,
} from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import BillingStatementFilter from "../model/BillingStatementFilter";
import { useToast } from "../comman/CustomMessages";
import BillingNodata from "../../images/billing-nodata.svg";
import NoRecordFound from "../comman/NoRecordFound";
import BillingStatements from "./BillingStatements";
import { FilterList } from "@mui/icons-material";
// Ensure this import path matches your project structure
import * as types from "../../redux/action/ActionType";
import {
  BILLING_STATEMENT_SELECT,
  SORT_PARAMS,
} from "../../redux/action/ActionType";
import BillingInfoModel from "../model/BillingInfoModel";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import { BILLING_STATEMENT_LIST_ROUTE } from "../../constants/RoutePath";

const moment = require("moment");
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const filterInitial = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};

const billingFilterInitial = {
  billingStartDateDatepicker: "",
  billingEndDateDatepicker: "",
  billingStartDate: "",
  billingEndDate: "",
  broker: [],
  invoiceStatus: "",
};

const selectBillingFilter = (state) => state.billingStatementFilter;

const BillingList = () => {
  const currentSort = useSelector((r) => r.SortReducer);
  const [loading, setLoading] = useState(false);
  const [isBillingStatementSearch, setIsBillingStatementSearch] =
    useState(false);
  const [list, setList] = useState([]);
  const showToast = useToast();
  const [total, setTotal] = useState(10);
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const [customerName, setCustomerName] = React.useState([]);
  const [personName, setPersonName] = React.useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [billingStatemntFlag, setBillingStatementFlag] = useState(false);
  const [filter, setFilter] = React.useState(filterInitial);
  console.log(filter, "filter123hstsysi");
  const [billingfilter, setBillingFilter] =
    React.useState(billingFilterInitial);
  const [clearFlag, setClearFlag] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [search, setSearch] = React.useState([]);
  const [applyFilterFlag, setApplyFilterFlag] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [userListApi, setUserListApi] = useState([]);
  const [isUserListDropdownLoaded, setIsUserListDropdownLoaded] =
    useState(false);
  const [userList, setUserList] = useState([]);
  console.log(billingfilter, "billingfilterbillingfilter");
  const userListSel = deCryptFun(useSelector((s) => s.AllCustomerListReducer));
  const [assignedCustomer, setAssignedCustomer] = React.useState([]);
  const [assignedProject, setAssignedProject] = useState([]);
  const reduxFilter = useSelector(selectBillingFilter);
  const [billingHelpButton, setBillingHelpButton] = React.useState(false);
  console.log(reduxFilter, "haaaaaaaaaaaaaa");
  const dispatch = useDispatch();
  const [billingStateOrderBy, setBillingStateOrderBy] = useState("");
  const [billingStateOrder, setBillingStateOrder] = useState("asc");

  // const projectListSel = deCryptFun(
  //   useSelector((s) => s.AllProjectListReducer)
  // );
  // const projectList = projectListSel ? JSON.parse(projectListSel).data : [];

  // const getLogUserRoleArray = getLogUserRole() && typeof getLogUserRole() !== "object" ? JSON.parse(getLogUserRole()) : [];
  // console.log("getLogUserRole()", getLogUserRole());
  const getLogUserRoleArray = getLogUserRole()
    ? JSON.parse(getLogUserRole())
    : [];

  var getLogUserRoleBoolean = false;
  if (
    getLogUserRoleArray &&
    getLogUserRoleArray.length > 0 &&
    getLogUserRoleArray.length === 1 &&
    getLogUserRoleArray[0] == "Admin"
  ) {
    getLogUserRoleBoolean = true;
  }
  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");
  const [periods, setPeriods] = useState([]);
  const [count, setCount] = useState(100);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [projectNewDropDownValues, setProjectNewDropDownValues] = useState([]);
  const [projectListDropdown, setProjectListDropdown] = useState([]);
  const [billingStatmentLoading, setBillingStatementLoading] = useState(true);
  console.log(projectNewDropDownValues, "periodsperiods");
  const [statusChangeFlag, setStatusChangeFlag] = useState(false);
  const [startMonth, setStartMonth] = useState("");
  const [numberOfMonths, setNumberOfMonths] = useState("");
  const [billPeriod, setBillPeriod] = useState("");
  const navigate = useNavigate();

  const currentMonthNumber = moment().month() + 1;

  const handleFilterChange = (event, newValue) => {
    setBillingFilter(billingFilterInitial);
    if (!newValue) {
      // Clear filter
      setFilter((prevState) => ({
        ...prevState,
        userId: "",
        projectId: "",
        filterValues: billingFilterInitial,
      }));
      dispatch({
        type: types.BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          userId: "",
          projectId: "",
          filterValues: billingFilterInitial,
        },
      });
      dispatch({
        type: SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });
      setProjectList([]);
      setProjectNewDropDownValues([]);
      setProjectListDropdown([]);
    } else {
      // Update filter with selected user
      setFilter((prevState) => ({
        ...prevState,
        userId: newValue.UserId,
        projectId: "",
        filterValues: billingFilterInitial,
      }));
      dispatch({
        type: types.BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          userId: newValue.UserId,
          projectId: "",
          filterValues: billingFilterInitial,
        },
      });
      setProjectList([]);
      setProjectNewDropDownValues([]);
      setProjectListDropdown([]);
    }
  };

  const handleFilterChange1 = (event, newValue) => {
    setBillingFilter(billingFilterInitial);
    if (!newValue) {
      // Clear filter
      setFilter((prevState) => ({
        ...prevState,
        projectId: "",
        filterValues: {},
      }));
      dispatch({
        type: types.BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          projectId: "",
          filterValues: {},
        },
      });
    } else {
      // Update filter with selected project
      setFilter((prevState) => ({
        ...prevState,
        projectId: newValue.ProjectId,
      }));
      dispatch({
        type: types.BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          projectId: newValue.ProjectId,
        },
      });
    }
  };

  // const handleFilterChange = (e, val) => {
  //   setBillingFilter(billingFilterInitial);
  //   setStatusChangeFlag(true);
  //   // setBillingStatementLoading(true);
  //   const { name, value } = e.target;

  //   if (name === "projectId") {
  //     const projectListData = projectList;
  //     dispatch(getPerDiemList(value));
  //     const selectedProject =
  //       projectListData &&
  //       projectListData.length > 0 &&
  //       projectListData.find((element) => element.ProjectId == value);
  //     setBillPeriod(
  //       selectedProject.BillingPeriod ? selectedProject.BillingPeriod : 0
  //     );
  //     setFilter((prevState) => ({
  //       ...prevState,
  //       projectId: value,
  //       filterValues: {},
  //     }));
  //     dispatch({
  //       type: types.BILLING_STATEMENT_SELECT,
  //       payload: {
  //         ...filter,
  //         projectId: value, // Assuming 'value' is the new project ID you want to set
  //         filterValues: {},
  //       },
  //     });
  //   }

  //   if (name === "userId") {
  //     setProjectList([]);
  //     setProjectNewDropDownValues([]);
  //     setProjectListDropdown([]);
  //     setFilter((prevState) => ({
  //       ...prevState,
  //       userId: value,
  //       projectId: "",
  //       projectStatus: "",
  //       filterValues: {},
  //     }));
  //     dispatch({
  //       type: types.BILLING_STATEMENT_SELECT,
  //       payload: {
  //         ...filter,
  //         userId: value,
  //         projectId: "", // Assuming 'value' is the new project ID you want to set
  //         projectStatus: "",
  //         filterValues: {},
  //       },
  //     });

  //     getProjectList(value);
  //   }

  //   dispatch({
  //     type: SORT_PARAMS,
  //     payload: { order: "", orderBy: "" },
  //   });

  //   // else {
  //   //   setFilter((prevState) => ({
  //   //     ...prevState,
  //   //     [name]: value,
  //   //   }));
  //   // }
  // };
  const handleCustomerProjectStatusChange = (name, val) => {
    setStatusChangeFlag(true);
    // setBillingStatementLoading(true);
    setBillingFilter(billingFilterInitial);
    let value = "";
    if (val === "yes") {
      value = true;
    } else if (val === "no") {
      value = false;
    }

    if (name === "customerStatus") {
      // setBillingStatementLoading(true);
      setFilter((prevState) => ({
        ...prevState,
        userId: "",
        projectId: "",
        projectStatus: "",
        filterValues: {},
      }));
      dispatch({
        type: types.BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          userId: "",
          projectId: "",
          projectStatus: "", // Assuming 'value' is the new project ID you want to set
          filterValues: {},
        },
      });
      console.log(filter, "vaaaaaaaaaaaaa");
      setProjectList([]);
      setProjectNewDropDownValues([]);
      setProjectListDropdown([]);

      var userListDropdown = [];
      if (userListApi && userListApi.length > 0) {
        userListDropdown = userListApi;
      }

      if (value === "") {
        setUserList(userListDropdown);
        console.log("value userListDropdown all -->", userListDropdown);
      }

      if (value === true) {
        const activeUsers =
          userListDropdown &&
          userListDropdown.length > 0 &&
          userListDropdown.filter((item) => item.Active == 1);
        console.log("value userListDropdown active -->", activeUsers);
        setUserList(activeUsers);
      }
      if (value === false) {
        const inActiveUsers =
          userListDropdown &&
          userListDropdown.length > 0 &&
          userListDropdown.filter((item) => item.Active == 0);
        console.log("value userListDropdown IN active -->", inActiveUsers);
        setUserList(inActiveUsers);
      }
    }

    if (name === "projectStatus") {
      // setBillingStatementLoading(true);
      setFilter((prevState) => ({
        ...prevState,
        projectId: "",
        filterValues: {},
      }));
      dispatch({
        type: types.BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          projectId: "", // Assuming 'value' is the new project ID you want to set
          filterValues: {},
        },
      });

      if (value === "") {
        setProjectList(projectListDropdown);
        setProjectNewDropDownValues(projectListDropdown);
      }
      if (value === true) {
        const activeProjects =
          projectListDropdown &&
          projectListDropdown.length > 0 &&
          projectListDropdown.filter((item) => item.Active === 1);
        setProjectList(activeProjects);
        setProjectNewDropDownValues(activeProjects);
      }
      if (value === false) {
        const inActiveProjects =
          projectListDropdown &&
          projectListDropdown.length > 0 &&
          projectListDropdown.filter((item) => item.Active === 0);
        setProjectList(inActiveProjects);
        setProjectNewDropDownValues(inActiveProjects);
      }
    }

    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    dispatch({
      type: types.BILLING_STATEMENT_SELECT,
      payload: {
        ...filter,
        [name]: value, // Assuming 'value' is the new project ID you want to set
      },
    });
    dispatch({
      type: SORT_PARAMS,
      payload: { order: "", orderBy: "" },
    });
  };

  console.log(filter, "vaaaaaaaaaaaaa");

  const clearBillingFilterFunc = () => {
    dispatch({
      type: types.BILLING_STATEMENT_SELECT,
      payload: {
        ...filter,
        filterValues: billingFilterInitial,
      },
    });
    setBillingFilter(billingFilterInitial);
    setApplyFilterFlag(false);
  };

  const filterOpenFun = () => {
    setOpenFilter(!openFilter);
    if (openFilter) {
      setApplyFilterFlag(false);
    }
  };

  // const handlePageChange = (e, value) => {
  //   setPage(value);
  // };

  const isAlreadyCovered = (periods, dateToCheck) => {
    for (let period of periods) {
      const dates = period.billingDate.split(" - ");
      const startDate = dates[0];
      const endDate = dates[1];

      if (dateToCheck === startDate || dateToCheck === endDate) {
        return true;
      }
    }
    return false;
  };

  const generateBillingPeriods = async (
    startMonth,
    numberOfMonths,
    billPeriod,
    billingArray,
    brokerArray
  ) => {
    const periods = [];
    const now = new Date();
const currentYear = now.getFullYear();
const currentMonthNow = now.getMonth() + 1;

const year =
  startMonth > currentMonthNow ? currentYear - 1 : currentYear;

    for (let month = startMonth; month < startMonth + numberOfMonths; month++) {
      const currentMonth = ((month - 1) % 12) + 1; // Adjust month within 1-12 range
      // const adjustedYear = year + Math.floor((month - 1) / 12); // Adjust year if month exceeds December
      const adjustedYear = year + (currentMonth < startMonth ? 1 : 0);


      // If the month is less than the start month, adjust to the previous year
      // if (currentMonth >= startMonth) {
      //   adjustedYear = year;
      // }

      console.log(currentMonth, adjustedYear, "adjusteeeeeeeeeee"); // Check the output to debug

      console.log(adjustedYear, "jj", month, startMonth);

      const daysInMonth = new Date(adjustedYear, currentMonth, 0).getDate(); // Get number of days in the month
       let startDay = 1;

      while (startDay <= daysInMonth) {
        let endDay = startDay + billPeriod - 1;

        if (endDay > daysInMonth) {
          endDay = daysInMonth;
        }

        if (endDay + billPeriod > daysInMonth) {
          endDay = daysInMonth;
        }

        // Format billing start and end dates
        const billingStart = moment(
          `${adjustedYear}-${currentMonth}-${startDay}`,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");

        const billingEnd = moment(
          `${adjustedYear}-${currentMonth}-${endDay}`,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");
        const billingStart1 = moment(
          `${adjustedYear}-${currentMonth}-${startDay}`,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");

        const billingEnd1 = moment(
          `${adjustedYear}-${currentMonth}-${endDay}`,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");

        const formattedMonth = String(currentMonth).padStart(2, "0"); // Ensure two-digit month
        const formattedDay = String(startDay).padStart(2, "0"); // Ensure two-digit day

        const billingStartList = moment(
          `${adjustedYear}-${formattedMonth}-${formattedDay}`,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");

        const billingEndList = moment(
          `${adjustedYear}-${formattedMonth}-${String(endDay).padStart(
            2,
            "0"
          )}`,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");

        console.log(billingStartList, "billingStartList", billingEndList);

        // Check if the period is not a single day and does not overlap with the next period
        const billingStatrCheck = billingStart || billingStart1
        const billingEndCheck = billingEnd  || billingEnd1
        if (
          !(startDay === endDay && isAlreadyCovered(periods, billingStatrCheck)) 
          && !isAlreadyCovered(periods, billingEndCheck)
        ) {
          const period = `${billingStart} - ${billingEnd}`;
          const period1 = `${billingStart1} - ${billingEnd1}`;

          let periodData = {
            billingStatementId: 0,
            userId: filter?.userId,
            billingDate: period,
            billingDateList: `${billingStartList} - ${billingEndList}`,
            billingDateListNew: `${billingStartList} - ${billingEndList}`,
            periodKey: dateToTimestamp(period),
            periodKeyMonth: dateToTimestamp(period1),
            projectId: filter.projectId,
            statusId: 0,
            billingStart: `${startDay}/${currentMonth}/${adjustedYear}`,
            billingEnd: `${endDay}/${currentMonth}/${adjustedYear}`,
            hours: 0,
            dayRate: 0,
            perDiem: 0,
            lodging: "",
            miles: "",
            misc: "",
            copies: "",
            mileageRate: "",
            total: "",
            lastModified: "",
            currentMonth: currentMonth,
            currentYear: adjustedYear,
          };

          periods.push(periodData);
        }

        startDay = endDay + 1;

        // Break the loop if startDay goes beyond the days in the month
        if (startDay > daysInMonth) {
          break;
        }
      }
    }

    /*
  for (let month = startMonth; month < startMonth + numberOfMonths; month++) {
    const currentMonth = ((month - 1) % 12) + 1; 
    const adjustedYear = year + Math.floor((month - 1) / 12);

    const daysInMonth = new Date(adjustedYear, currentMonth, 0).getDate();
    let startDay = 1;

    while (startDay <= daysInMonth) {
      let endDay = startDay + billPeriod - 1;

      if (endDay > daysInMonth) {
        endDay = daysInMonth;
      }

      if (endDay + billPeriod > daysInMonth) {
        endDay = daysInMonth;
      }

      const billingStart = moment(
        `${adjustedYear}-${currentMonth}-${startDay}`
      ).format("DD/MM/YYYY");
      const billingEnd = moment(
        `${adjustedYear}-${currentMonth}-${endDay}`
      ).format("DD/MM/YYYY");

      const period = `${billingStart} - ${billingEnd}`;
      let periodData = {
        billingStatementId: 0,
        userId: filter.userId,
        billingDate: period,
        periodKey: dateToTimestamp(period),
        projectId: filter.projectId,
        statusId: 0,
        billingStart: `${startDay}/${currentMonth}/${adjustedYear}`,
        billingEnd: `${endDay}/${currentMonth}/${adjustedYear}`,
        hours: 0,
        dayRate: 0,
        perDiem: 0,
        lodging: "",
        miles: "",
        misc: "",
        copies: "",
        mileageRate: "",
        total: "",
        lastModified: "",
        currentMonth: currentMonthNumber === currentMonth ? true : false,
      };
      
      periods.push(periodData);

      startDay += billPeriod;

      if (startDay > daysInMonth) {
        break;
      }
    }
  }
  */

    billingArray &&
      billingArray.length > 0 &&
      billingArray.forEach((billing) => {
        periods.forEach((dateItem) => {
          console.log(periods,'periodsperiodsperiodsperiods',billingArray)
          if (
            (dateItem.periodKey === billing.PeriodKey || dateItem.periodKeyMonth === billing.PeriodKey) &&
            billing.UserID == getLogUserId()
          ) {
            dateItem["billingStatementId"] = billing.billingStatementId;
            dateItem["userId"] = billing.UserID;
            dateItem["periodKey"] = billing.PeriodKey;
            dateItem["projectId"] = billing.ProjectID;
            dateItem["statusId"] = billing.StatusID;
            dateItem["hours"] = billing.Hours;
            dateItem["dayRate"] = billing.DayRate;
            dateItem["perDiem"] = billing.PerDiem;
            dateItem["lodging"] = billing.Lodging;
            dateItem["miles"] = billing.Miles;
            dateItem["brokerName"] = billing.BrokerName;
            dateItem["misc"] = billing.Misc;
            dateItem["copies"] = billing.Copies;
            dateItem["mileageRate"] = billing.MileageRate;
            dateItem["total"] = billing.Total;
            dateItem["lastModified"] = billing.LastModified;
            if (billing.StatusID == 1 && brokerArray && brokerArray[0]) {
              dateItem["dayRate"] = brokerArray[0].DayRate;
              dateItem["mileageRate"] = brokerArray[0].MileageRate;
            }
          }
        });
      });

    return periods;
  };

  const generateBillingPeriods1 = async (
    invoiceFilter,
    billPeriod,
    billingArray,
    brokerArray
  ) => {
    const { billingStartDate, billingEndDate } = invoiceFilter;
    const periodsArray = [];

    if (!billingStartDate || !billingEndDate) {
      console.error("Start date or end date is missing");
      return periodsArray;
    }

    console.log(billingArray, "billingArraybillingArray", invoiceFilter);
    console.log(billPeriod, "billPeriodbillPeriodbillPeriodss");
    console.log(brokerArray, "brokerArraybrokerArraybrokerArray");

    const startMonth = moment(billingStartDate, "YYYY-MM-DD").month() + 1;
    const endMonth = moment(billingEndDate, "YYYY-MM-DD").month() + 1;
    const startYear = moment(billingStartDate, "YYYY-MM-DD").year();
    const endYear = moment(billingEndDate, "YYYY-MM-DD").year();

    console.log(startMonth, "monthhhhhhhh", endMonth, startYear, endYear);

    for (let year = startYear; year <= endYear; year++) {
      const loopStartMonth = year === startYear ? startMonth : 1;
      const loopEndMonth = year === endYear ? endMonth : 12;

      // Iterate through months for the given year range
      for (let month = loopStartMonth; month <= loopEndMonth; month++) {
        const daysInMonth = new Date(year, month, 0).getDate(); // Get the number of days in the current month
        let startDay = 1; // Start of the billing period

        // Iterate through billing periods for the given month
        while (startDay <= daysInMonth) {
          let endDay = startDay + billPeriod - 1; // Calculate endDay

          if (endDay > daysInMonth) {
            endDay = daysInMonth; // Adjust end day to the last day of the month
          }
          if (endDay + billPeriod > daysInMonth) {
            endDay = daysInMonth; // Set endDay to the last day of the month
          }

          // Create billing start and end dates in format (DD/MM/YYYY)
          const billingStart = moment(
            `${year}-${month}-${startDay}`,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          const billingEnd = moment(
            `${year}-${month}-${endDay}`,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");

          const billingStart1 = moment(
            `${year}-${String(month).padStart(2, "0")}-${String(
              startDay
            ).padStart(2, "0")}`,
            "YYYY-MM-DD"
          ).format("MM/DD/YYYY");

          const billingEnd2 = moment(
            `${year}-${String(month).padStart(2, "0")}-${String(
              endDay
            ).padStart(2, "0")}`,
            "YYYY-MM-DD"
          ).format("MM/DD/YYYY");

          console.log(
            "Billing Start:",
            billingStart,
            "Billing End:",
            billingEnd
          );

          const billingStatrCheck = billingStart || billingStart1;
          const billingEndCheck = billingEnd || billingEnd2;

          // Ensure the billing period is not already covered (existing condition)
          if (
            !(
              startDay === endDay &&
              isAlreadyCovered(periodsArray, billingStatrCheck)
            ) &&
            !isAlreadyCovered(periodsArray, billingEndCheck)
          ) {
            const period = `${billingStart} - ${billingEnd}`;
            const period1 = `${billingStart1} - ${billingEnd2}`;

            const periodData = {
              billingStatementId: 0,
              userId: filter?.userId,
              billingDate: period,
              periodKey: dateToTimestamp(period),
              periodKeyMonth: dateToTimestamp(period1),
              projectId: filter.projectId,
              billingDateList: period,
              billingDateListNew: period1,
              statusId: 0,
              BillingStart: moment(billingStart, "DD/MM/YYYY").toISOString(),
              BillingEnd: moment(billingEnd, "DD/MM/YYYY").toISOString(),
              BillingDate: period,
              hours: 0,
              dayRate: 0,
              perDiem: 0,
              lodging: "",
              miles: "",
              misc: "",
              copies: "",
              mileageRate: "",
              total: "",
              lastModified: "",
            };

            periodsArray.push(periodData);
          }

          startDay = endDay + 1; // Move to the next billing period

          if (startDay > daysInMonth) {
            break; // Exit the while loop and move to the next month
          }
        }
      }
    }

    // Updating periodsArray with billing details from billingArray
    console.log(billingArray, "billinaaaaaaaaa");
    console.log(periodsArray, "periodsArrayperiodsArray");
    billingArray?.forEach((billing) => {
      periodsArray.forEach((dateItem) => {
        if (
          (dateItem.periodKey === billing.PeriodKey || dateItem.periodKeyMonth === billing.PeriodKey ) &&
          billing.UserID === getLogUserId()
        ) {
          dateItem["billingStatementId"] = billing.billingStatementId;
          dateItem["userId"] = billing.UserID;
          dateItem["periodKey"] = billing.PeriodKey;
          dateItem["projectId"] = billing.ProjectID;
          dateItem["statusId"] = billing.StatusID;
          dateItem["hours"] = billing.Hours;
          dateItem["dayRate"] = billing.DayRate;
          dateItem["perDiem"] = billing.PerDiem;
          dateItem["lodging"] = billing.Lodging;
          dateItem["miles"] = billing.Miles;
          dateItem["brokerName"] = billing.BrokerName;
          dateItem["misc"] = billing.Misc;
          dateItem["copies"] = billing.Copies;
          dateItem["mileageRate"] = billing.MileageRate;
          dateItem["total"] = billing.Total;
          dateItem["lastModified"] = billing.LastModified;
          if (billing.StatusID == 1 && brokerArray && brokerArray[0]) {
            dateItem["dayRate"] = brokerArray[0].DayRate;
            dateItem["mileageRate"] = brokerArray[0].MileageRate;
          }
        }
      });
    });

    console.log(periodsArray, "periodsArray");

    return periodsArray;
  };

  const getBillingStatementDetails = async () => {
    setLoading(true);
    const { userId, projectId, filterValues } = reduxFilter;
    const { billingStartDate, billingEndDate, broker, invoiceStatus } =
      billingfilter;
    console.log(
      billingEndDate,
      "selectBillingFilter987",
      billingStartDate,
      invoiceStatus
    );
    console.log(filterValues, "selectBillingFilter987987654");
    let data = {
      count: count,
      offset: page,
    };

    if (getLogUserRoleBoolean) {
      data.isOrphaned = getLogUserRoleBoolean;
    }

    if (userId) {
      data.customerId = userId;
    }

    if (projectId) {
      data.projectId = projectId;
    }

    // if (applyFilterFlag) {
    if (billingStartDate) {
      data.billingStart = billingStartDate;
    }

    if (billingEndDate) {
      data.billingEnd = billingEndDate;
    }

    if (broker && broker.length > 0) {
      data.brokerId = broker.join(",");
    }

    if (invoiceStatus) {
      data.statusId = invoiceStatus;
    }

    data.brokerId = getLogUserId();
    // }

    const config = {
      method: "GET",
      url: GET_ALL_BILLING_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setList(parsedResponse.data);
        // setTotal(Math.ceil(parsedResponse.totalCount / 10));
        // return parsedResponse.data; // Return the data for further processing
        return parsedResponse;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          setFilter(filterInitial);
          setBillingFilter(billingFilterInitial);
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              filterValues: {},
            },
          });
          showToast(v?.message?.message, "error");
          // navigate(BILLING_STATEMENT_LIST_ROUTE)
          // getAllProjectsList
        } else {
          showToast(v?.message, "error");
        }
      }
      return null; // Return null on error
    } finally {
      setLoading(false);
    }
  };

  const getProjectList = async (customerId, projectArray) => {
    setBillingStatementLoading(true);
    if (customerId) {
      let data = {
        count: count,
        offset: page,
        customerId: customerId,
      };
      const config = {
        method: "GET",
        url: GET_ALL_PROJECT_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.data && parsedResponse.data.length > 0) {
          const filteredData = parsedResponse.data.map((item) => ({
            Name: item.Name,
            ProjectId: item.ProjectId,
            BillingPeriod: item.BillingPeriod,
            Active: item.Active,
          }));

          const matchedProjectIDs = projectArray?.filter(
            (project) => project.CustomerID === customerId
          );
          const mappingValuue = matchedProjectIDs.map(
            (project1) => project1.ProjectID
          );

          // Step 2: Filter mainArray based on the matched ProjectIDs
          const filteredMainArray = filteredData.filter((project) =>
            mappingValuue.includes(project.ProjectId)
          );
          console.log(filteredMainArray, "ajssssssssssssss");
          setProjectList(filteredMainArray);
          setProjectNewDropDownValues(filteredData);
          setProjectListDropdown(filteredMainArray);
        } else {
          setProjectList([]);
          setProjectListDropdown([]);
          setProjectNewDropDownValues([]);
          setBillingStatementLoading(false);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          // if(v.message == "Access Denied.Your account no longer has access to this service."){
          //   dispatch({
          //     type: types.BILLING_STATEMENT_SELECT,
          //     payload: {
          //       customerStatus: "",
          //       projectStatus: "",
          //       userId: "",
          //       projectId: "",
          //       filterValues: {}
          //     }
          //   })
          //   navigate(BILLING_STATEMENT_LIST_ROUTE)
          //  }
        }
        // setBillingStatementLoading(false);
        return null; // Return null on error
      }
    } else {
      setProjectList([]);
      setProjectNewDropDownValues([]);
      setProjectListDropdown([]);
      // setBillingStatementLoading(false)
    }
  };

  const billingMoveClick = (value) => {
    if (value.billingStatementId) {
      navigate(`/statement/${value.billingStatementId}`);
      if (value.statusId === 2) {
        showToast(
          "Statement is closed and must be reopened to edit. This statement has not yet been invoiced so you may still reopen it for edit.",
          "reopenBilling"
        );
      } else if (value.statusId === 3) {
        showToast(
          "Statement is closed and cannot be reopoened because it is attached to an open invoice. To edit this statement you must ask an administrator to detatach it from the invoice. Then the statement can be reopened and will be eligible for edit.",
          "reopenBilling"
        );
      }
    } else {
      const dateToTimestampValue = dateToTimestamp(value.billingDate);
      var dates = value.billingDate.split(" - ");

      let postData = {
        billingStatementId: 0,
        userId: getLogUserId(),
        periodKey: dateToTimestampValue,
        projectId: filter.projectId,
        statusId: 1,
        billingStart: convertDateFormat(dates[0]),
        billingEnd: convertDateFormat(dates[1]),
        hours: 0,
        dayRate: 0,
        perDiem: 0,
        lodging: "",
        miles: "",
        misc: "",
        copies: "",
        mileageRate: "",
        total: "",
        isOrphaned: false,
      };

      if (!postData.billingStatementId) {
        setSelectedPeriod(postData);
        setOpen(true);
      }
    }
  };

  const convertDateFormat = (dateStr) => {
    const parts = dateStr.split("/");
    if (parts.length !== 3) return dateStr; // Handle invalid input

    // const formattedDate = `${parts[2]}/${parts[0].padStart(
    //   2,
    //   "0"
    // )}/${parts[1].padStart(2, "0")}`;
    let formattedDate
   if(((billingfilter?.billingStartDate ||
        billingfilter?.billingEndDate ||
        billingfilter?.invoiceStatus ||
        billingfilter?.broker?.length > 0) &&
        applyFilterFlag) ||
        billingfilter?.billingStartDate ||
        billingfilter?.billingEndDate ||
        billingfilter?.invoiceStatus ||
        billingfilter?.broker?.length > 0 ){
     formattedDate = `${parts[2]}/${parts[1].padStart(
      2,
      "0"
    )}/${parts[0].padStart(2, "0")}`;
   }else{
     formattedDate = `${parts[2]}/${parts[0].padStart(
      2,
      "0"
    )}/${parts[1].padStart(2, "0")}`;
   }
    return formattedDate;
  };

  const dateToTimestamp = (dateStr) => {
    var dates = dateStr.split(" - ");
    var startDateStr = dates[0];
    var endDateStr = dates[1];
    var startDateStrparts = startDateStr.split("/");
    var endDateStrparts = endDateStr.split("/");
    var startDateTimestamp = startDateStrparts.join("");
    var endDateTimestamp = endDateStrparts.join("");
    return startDateTimestamp.toString() + endDateTimestamp.toString();
  };

  const createBilling = async (value) => {
    setOpen(false);

    if (value === true && !selectedPeriod.billingStatementId) {
      const config = {
        method: "POST",
        url: CREATE_UPDATE_BILLING_STATEMENT_URL,
        headers: authHeader(),
        data: {
          webString: enCryptFun(JSON.stringify(selectedPeriod)),
        },
      };
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          navigate(`/statement/${parsedResponse.billingStatementId}`);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          if (v?.message?.accessDenied == 1) {
            showToast(v?.message?.message, "error");
            dispatch({
              type: types.BILLING_STATEMENT_SELECT,
              payload: {
                customerStatus: "",
                projectStatus: "",
                projectId: "",
                userId: "",
                filterValues: {},
              },
            });
            setFilter(filterInitial);
            setBillingFilter(billingFilterInitial);
            dispatch({
              type: types.ADMIN_BILLING_STATEMENT_SELECT,
              payload: {
                customerStatus: "",
                projectStatus: "",
                userId: "",
                projectId: "",
                filterValues: {},
              },
            });
            navigate(BILLING_STATEMENT_LIST_ROUTE);
          } else {
            showToast(v?.message, "error");
          }
        }
      }
    }
  };

  const filterClose = () => {
    setOpenFilter(false);
  };

  const submitFilter = () => {
    setOpenFilter(false);
    setApplyFilterFlag(true);
  };

  const getFutureMonth = (currentMonth, numberOfMonths) => {
    let MonthStart = currentMonth - 3; // Change from -4 to -3
    if (MonthStart < 1) {
      MonthStart += 12; // Wrap around to the previous year
    }
    return MonthStart;
  };

  function parseDate(dateStr) {
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  }

  const getBillingStatementFilterList = () => {
    setBillingStatementLoading(true);
    const selectedProject =
      projectList &&
      projectList?.length > 0 &&
      projectList.find(
        (element) => element?.ProjectId == reduxFilter?.projectId
      );
    console.log(selectedProject, "selectedProjectselectedProject");
    console.log(reduxFilter.filterValues, "projectListjjjjjj");
    console.log(filter, "projfilterectListjjjjjj");
    setBillPeriod(
      selectedProject?.BillingPeriod != 0 ? selectedProject?.BillingPeriod : 0
    );
    if (filter.userId && filter.projectId) {
      (async () => {
        try {
          const billingStatementData = await getBillingStatementDetails();

          var billingStatementDataBilling = billingStatementData.data
            ? billingStatementData.data
            : [];
          var billingStatementDataBroker =
            billingStatementData.projectBrkerDetails
              ? billingStatementData.projectBrkerDetails
              : [];

          if (billingStatementData) {
            const numberOfMonthsVal = 7;
            const billPeriodVal = selectedProject?.BillingPeriod || billPeriod;
            const startMonthVal = getFutureMonth(
              currentMonthNumber,
              numberOfMonthsVal
            );

            setStartMonth(startMonthVal);
            setNumberOfMonths(numberOfMonthsVal);
            setBillPeriod(billPeriodVal);

            const generatedPeriods = await generateBillingPeriods(
              startMonthVal,
              numberOfMonthsVal,
              billPeriodVal,
              billingStatementDataBilling,
              billingStatementDataBroker
            );

            console.log(generatedPeriods, "llllllllllll");

            const generatedPeriods1 = await generateBillingPeriods1(
              billingfilter,
              billPeriodVal, // Ensure this matches the expected format
              billingStatementDataBilling,
              billingStatementDataBroker
            );
            console.log("generatedPeriods", generatedPeriods1);

            if (
              (billingfilter.billingStartDate &&
                billingfilter.billingEndDate) ||
              billingfilter.invoiceStatus
            ) {
              var filteredData = [];

              if (
                billingfilter.billingStartDate &&
                billingfilter.billingEndDate &&
                !billingfilter.invoiceStatus
              ) {
                const filterStartDate = moment(
                  billingfilter.billingStartDate,
                  "YYYY-MM-DD"
                ).valueOf();
                const filterEndDate = moment(
                  billingfilter.billingEndDate,
                  "YYYY-MM-DD"
                ).valueOf();

                console.log(
                  filterEndDate,
                  filterStartDate,
                  "filterStartDatefilterStartDate"
                );
                filteredData = generatedPeriods1.filter((item) => {
                  console.log(item, "itemmmmmm");
                  const itemStartDateMoment = moment(
                    item.BillingStart,
                    "YYYY-MM-DD"
                  );
                  console.log(
                    itemStartDateMoment,
                    "itemStartDateMomentitemStartDateMoment"
                  );

                  const itemStartDate = itemStartDateMoment.valueOf();

                  const itemEndDateMoment = moment(
                    item.BillingEnd,
                    "YYYY-MM-DD"
                  );
                  const itemEndDate = itemEndDateMoment.valueOf();
                  console.log(
                    itemStartDate,
                    itemEndDate,
                    "filterStartDitemEndDateatefilterStartDate"
                  );

                  return (
                    itemStartDate <= filterEndDate &&
                    itemEndDate >= filterStartDate
                  );
                });
                console.log(filteredData, "filterrrrrrr");
              } else if (
                !billingfilter.billingStartDate &&
                !billingfilter.billingEndDate &&
                billingfilter.invoiceStatus
              ) {
                filteredData = generatedPeriods.filter((item) => {
                  return billingfilter.invoiceStatus == item.statusId;
                });
              } else if (
                billingfilter.billingStartDate &&
                billingfilter.billingEndDate &&
                billingfilter.invoiceStatus
              ) {
                const filterStartDate = moment(
                  billingfilter.billingStartDate,
                  "YYYY-MM-DD"
                ).valueOf();
                const filterEndDate = moment(
                  billingfilter.billingEndDate,
                  "YYYY-MM-DD"
                ).valueOf();

                filteredData = generatedPeriods1.filter((item) => {
                  const itemStartDateMoment = moment(
                    item.BillingStart,
                    "YYYY-MM-DD"
                  );
                  const itemStartDate = itemStartDateMoment.valueOf();

                  const itemEndDateMoment = moment(
                    item.BillingEnd,
                    "YYYY-MM-DD"
                  );
                  const itemEndDate = itemEndDateMoment.valueOf();

                  // return (
                  //   itemStartDate >= filterStartDate &&
                  //   itemEndDate <= filterEndDate &&
                  //   billingfilter.invoiceStatus == item.statusId
                  // );

                  return (
                    itemStartDate <= filterEndDate &&
                    itemEndDate >= filterStartDate &&
                    billingfilter.invoiceStatus == item.statusId
                  );
                });
              }

              setPeriods(filteredData);
              setBillingStatementLoading(false);
            } else {
              setPeriods(generatedPeriods);
              setBillingStatementLoading(false);
            }

            setIsBillingStatementSearch(true);
          } else {
            setBillingFilter(billingFilterInitial);
            setFilter(filter);
            dispatch({
              type: types.BILLING_STATEMENT_SELECT,
              payload: {
                ...filter,
                filterValues: {},
              },
            });
            setBillingStatementLoading(false);
          }
        } catch (error) {
          console.error("Error fetching billing details:", error);
          setBillingStatementLoading(false);
        }
      })();
    } else {
      setIsBillingStatementSearch(false);
      // setBillingStatementLoading(false);
    }
  };

  // useEffect(() => {
  //   getBillingStatementFilterList();
  // }, [filter.userId, filter.projectId]);

  useEffect(() => {
    getBillingStatementFilterList();
  }, [applyFilterFlag]);

  useEffect(() => {
    if (!openFilter && applyFilterFlag) {
      getBillingStatementFilterList();
    }
  }, [applyFilterFlag, openFilter]);

  useEffect(() => {
    if (
      userListSel &&
      JSON.parse(userListSel).data &&
      JSON.parse(userListSel).data.length > 0 &&
      assignedCustomer.length > 0
    ) {
      let userData =
        JSON.parse(userListSel).data && JSON.parse(userListSel).data;
      const customerIds = new Set(
        assignedCustomer.map((customer) => customer.CustomerID)
      );
      const fiterUserData = userData.filter((user) =>
        customerIds.has(user.UserId)
      );

      if (!isUserListDropdownLoaded) {
        setUserList(fiterUserData);
      }
      setUserListApi(fiterUserData);

      setIsUserListDropdownLoaded(true);
    }
  }, [userListSel, assignedCustomer]);

  const getDashboardFilterBroker = async () => {
    setBillingStatementLoading(true);
    const brokerInitial = {
      customerId: "",
      projectId: "",
      brokerId: getLogUserId(),
    };

    const config = {
      method: "GET",
      url: GET_BROKER_BILLING_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(brokerInitial)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      const { status, data } = parsedResponse;

      if (status === "Success" && data && data[0]) {
        // const brokerArray = data[0].customerDetails;
        const customerArray = data.map((customer) => ({
          CustomerID: customer.CustomerID,
          CustomerName: customer.CustomerName,
        }));
        setAssignedCustomer(customerArray);

        const projectArray = data.flatMap((customer) =>
          customer.projectDetails.map((project) => ({
            CustomerID: customer.CustomerID,
            ProjectID: project.ProjectID,
            ProjectName: project.ProjectName,
          }))
        );
        console.log("Project Array:", projectArray);
        setAssignedProject(projectArray); // Update state for any other use
        // Call getProjectList after setting assignedProject
        if (reduxFilter?.userId) {
          await getProjectList(reduxFilter.userId, projectArray);
        }
      }
    } catch (error) {
      console.error("An error occurred in getDashboardFilterBroker:", error);
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              userId: "",
              filterValues: {},
            },
          });
          setFilter(filterInitial);
          setBillingFilter(billingFilterInitial);
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          navigate(BILLING_STATEMENT_LIST_ROUTE);
        } else if (v?.message != "No record found.") {
          showToast(v?.message, "error");
        }
      }
    } finally {
      if (reduxFilter?.userId == "") {
        setBillingStatementLoading(false);
      }
    }
  };
  // useEffect(() => {
  //   console.log("Assigned Projects updated:", assignedProject);
  //   setAssignedProject({...assignedProject})
  // }, [assignedProject]);

  // useEffect(() => {
  //   if(filter.projectId){
  //     dispatch(getPerDiemList(filter.projectId))
  //   }
  // }), [filter.projectId];

  // useEffect(() => {
  //   getProjectList(filter.userId)
  // }), [filter.userId];
  useEffect(() => {
    const loadData = async () => {
      try {
        await getDashboardFilterBroker();
        console.log(
          reduxFilter?.userId,
          filter?.userId,
          'reduxFilter?.userId && filter?.userId == ""'
        );
        if (
          reduxFilter?.userId !== "" &&
          filter?.userId == "" &&
          !statusChangeFlag
        ) {
          setBillingFilter((prevFilter) => ({
            ...prevFilter,
            ...reduxFilter.filterValues,
          }));
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: reduxFilter,
          });
          setFilter((prevFilter) => ({ ...prevFilter, ...reduxFilter }));
        } else {
          await dispatch(getAllCustomersList());
          setBillingFilter(billingfilter);
          setBillingStatementLoading(false);
          // dispatch({
          //     type: types.ADMIN_BILLING_STATEMENT_SELECT,
          //     payload: filter,
          // });
          // setFilter({ ...filter });
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      } finally {
        // if (reduxFilter?.userId && !filter?.userId) {
        //   setBillingStatementLoading(false);
        // }
      }
    };

    // if (reduxFilter?.userId && !filter?.userId) {
    loadData();
    // } else {
    // setBillingStatementLoading(false);
    // }
  }, [reduxFilter, dispatch, filter.userId]);

  // Adjust dependencies as needed

  useEffect(() => {
    console.log(
      reduxFilter?.userId,
      "reduxFilter?.userIdreduxFilter?.userId",
      assignedProject.length > 0
    );
    // Trigger getProjectList only when assignedProject has been set
    if (assignedProject.length > 0 && reduxFilter?.userId) {
      getProjectList(reduxFilter.userId);
    }
  }, [assignedProject, reduxFilter.userId]);

  useEffect(() => {
    getBillingStatementFilterList();
  }, [filter.userId, filter.projectId]);

  const userRoles = getLogUserRole();

  const testing1 =
    (userRoles.includes("Admin") && userRoles.includes("Broker")) ||
    userRoles.includes("Admin")
      ? "3"
      : "0";

  const sortedLocationList = useMemo(() => {
    periods.forEach((statement) => {
      statement.miles = statement.miles ? statement.miles : 0;
      statement.mileageRate = statement.mileageRate
        ? parseFloat(statement.mileageRate).toFixed(3)
        : (0).toFixed(3);
      statement.perDiem = statement.perDiem
        ? parseFloat(statement.perDiem).toFixed(2)
        : (0).toFixed(2);
      statement.statusId = statement.statusId ? statement.statusId : 0;
    });

    if (billingStateOrderBy) {
      console.log("periods -->", periods);

      return [...periods].sort((a, b) => {
        if (billingStateOrderBy === "TaxRate") {
          const valueA = a[billingStateOrderBy];
          const valueB = b[billingStateOrderBy];

          if (billingStateOrder === "asc") {
            return valueA - valueB;
          } else {
            return valueB - valueA;
          }
        } else if (
          billingStateOrderBy === "hours" ||
          billingStateOrderBy === "dayRate" ||
          billingStateOrderBy === "miles" ||
          billingStateOrderBy === "mileageRate" ||
          billingStateOrderBy === "perDiem" ||
          billingStateOrderBy === "statusId"
        ) {
          const valueA = parseFloat(a[billingStateOrderBy]);
          const valueB = parseFloat(b[billingStateOrderBy]);
          console.log(valueA, valueB, "valueA - valueB");
          return billingStateOrder === "asc"
            ? valueA - valueB
            : valueB - valueA;
        } else {
          const valueA = a[billingStateOrderBy]?.toLowerCase();
          const valueB = b[billingStateOrderBy]?.toLowerCase();

          if (billingStateOrder === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        }
      });
    }
    return periods;
  }, [periods, billingStateOrderBy, billingStateOrder]);

  console.log(sortedLocationList, "sortedLocationListsortedLocationList");

  const handleLocationSortRequest = (property) => {
    const isAsc =
      billingStateOrderBy === property && billingStateOrder === "asc";
    if (billingStateOrderBy === property && billingStateOrder === "desc") {
      setBillingStateOrder("");
      setBillingStateOrderBy("");
      dispatch({
        type: SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });
    } else {
      setBillingStateOrder(isAsc ? "desc" : "asc");
      setBillingStateOrderBy(property);
      dispatch({
        type: SORT_PARAMS,
        payload: { order: isAsc ? "desc" : "asc", orderBy: property },
      });
    }
  };

  const getLocationSortIcon = (orderByValue) => {
    if (billingStateOrderBy === orderByValue) {
      return billingStateOrder === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  useEffect(() => {
    if (currentSort) {
      setBillingStateOrder(currentSort.order);
      setBillingStateOrderBy(currentSort.orderBy);
    }
  }, [currentSort]);

  const activeUserCheck = userList?.length > 0 ? userList?.find((item)=> item?.UserId == reduxFilter?.userId) : []
  const activeProjectCheck = periods?.length > 0 ? projectList.find((project) => project.ProjectId === filter?.projectId) : []

  console.log(activeProjectCheck, activeUserCheck, 'activeUserCheckactiveUserCheck')

  return (
    <>
      {/* {billingStatmentLoading && <CustomPageLoading />} */}
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar highlightSide={testing1} />
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title="Billing Statements" backFlag={false} backRoute={""} />

          <BillingStatementMenu getLogUserRole={getLogUserRoleArray} />

          {/* Filter Section */}
          <Box className="secound-bg-box user-log">
            <p
              style={{ marginBottom: "25px", fontWeight: "400" }}
              className="label"
            >
              Select a customer & project to view, edit, and create billing
              statements.
              <span
                onClick={() => {
                  setBillingHelpButton(true);
                }}
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  position: "absolute",
                  color: "#898989",
                }}
                class="material-symbols-outlined"
              >
                help
              </span>
            </p>
            <Grid container>
              <Grid
                sx={{
                  pr: { xs: "0", md: "30px" },
                  opacity: billingStatmentLoading == true ? 0.5 : 1, // Reduce opacity to indicate disabled state
                  pointerEvents:
                    billingStatmentLoading == true ? "none" : "auto", // Prevent interaction
                }}
                xs={12}
                md={6}
              >
                {/* Customer Status */}

                <Box className="billing-active-checkbox">
                  <p style={{ marginBottom: "0px" }} className="label oh-label">
                    Customer
                  </p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "all",
                            console.log("CALLLLINGGGGG")
                          )
                        }
                        checked={filter?.customerStatus === "" ? true : false}
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="All"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "yes"
                          )
                        }
                        checked={filter?.customerStatus === true ? true : false}
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "no"
                          )
                        }
                        checked={
                          filter?.customerStatus === false ? true : false
                        }
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="Inactive"
                  />
                </Box>
                <FormControl
                  sx={{ width: "100%" }}
                  variant="standard"
                  disabled={billingStatmentLoading} // Apply the disabled state to FormControl
                >
                  <Autocomplete
                    sx={{
                      width: "100%",
                      fontSize: "14px !important",
                      // "& .MuiAutocomplete-inputRoot": {
                      //   paddingRight: "10px !important",
                      // },
                      "& .MuiAutocomplete-input": {
                        color:
                          filter.userId === ""
                            ? "#212121 !important"
                            : "#212121 !important",
                        fontSize: "14px !important",
                        // height: '25px !important'
                      },
                    }}
                    options={userList || []}
                    getOptionLabel={(option) => option.Name || ""}
                    value={
                       Array.isArray(userList)
                    ? userList.find((user) => user.UserId === filter.userId) || null
                    : null
                    }
                    onChange={handleFilterChange}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) =>
                      setInputValue(newInputValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search Customer"
                        sx={{
                          height: "25px !imporatant",
                          color: "#212121 !important",
                          fontSize: "14px !important",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {/* {billingStatmentLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null} */}
                              {params.InputProps.endAdornment}
                                {activeUserCheck && filter.userId && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => {
                                      // Reset projectId when remove button is clicked
                                      setFilter((prevState) => ({
                                        ...prevState,
                                        userId: "",
                                        projectId: "",
                                        filterValues: {},
                                      }));
                                      dispatch({
                                        type: types.BILLING_STATEMENT_SELECT,
                                        payload: {
                                          ...filter,
                                          userId: "",
                                          projectId: "",
                                          filterValues: {},
                                        },
                                      });
                                    }}
                                  >
                                    <HighlightOffIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              )}
                              {/* {filter.userId && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => {
                                      // Reset projectId when remove button is clicked
                                      setFilter((prevState) => ({
                                        ...prevState,
                                        userId: "",
                                        projectId: "",
                                        filterValues: {},
                                      }));
                                      dispatch({
                                        type: types.BILLING_STATEMENT_SELECT,
                                        payload: {
                                          ...filter,
                                          userId: "",
                                          projectId: "",
                                          filterValues: {},
                                        },
                                      });
                                    }}
                                  >
                                    <HighlightOffIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              )} */}
                            </>
                          ),
                        }}
                      />
                    )}
                    noOptionsText="No customers found"
                    clearOnEscape
                    disabled={billingStatmentLoading}
                    renderOption={(props, option) => (
                      <li
                        style={{
                          color: "#212121 !important",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                        {...props}
                        key={option.UserId}
                      >
                        {option.Name}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.UserId === value.UserId
                    }
                  />
                </FormControl>
              </Grid>
              <Grid
                sx={{
                  pl: { xs: "0", md: "30px" },
                  opacity:
                    activeUserCheck == undefined || billingStatmentLoading == true || filter?.userId === ""
                      ? 0.5
                      : 1, // Reduce opacity to indicate disabled state
                  pointerEvents:
                   activeUserCheck == undefined ||  billingStatmentLoading == true || filter?.userId === ""
                      ? "none"
                      : "auto", // Prevent interaction
                }}
                xs={12}
                md={6}
              >
                {/* Project Status */}
                <Box
                  sx={{ mt: { xs: "10px !important", sm: "0px !important" } }}
                  className="billing-active-checkbox"
                >
                  <p style={{ marginBottom: "0px" }} className="label oh-label">
                    Project
                  </p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "all"
                          )
                        }
                        checked={!activeUserCheck || filter?.projectStatus === "" ? true : false}
                        sx={{ color: "gray" }}
                        disabled={
                          activeUserCheck == undefined || billingStatmentLoading == true ||
                          filter?.userId === ""
                        } // Conditionally disable
                      />
                    }
                    label="All"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "yes"
                          )
                        }
                        checked={activeUserCheck && filter?.projectStatus === true ? true : false}
                        sx={{ color: "gray" }}
                        disabled={
                          activeUserCheck == undefined || billingStatmentLoading == true ||
                          filter?.userId === ""
                        } // Conditionally disable
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "no"
                          )
                        }
                        checked={activeUserCheck && filter?.projectStatus === false ? true : false}
                        sx={{ color: "gray" }}
                        disabled={
                          activeUserCheck == undefined || billingStatmentLoading == true ||
                          filter?.userId === ""
                        } // Conditionally disable
                      />
                    }
                    label="Inactive"
                  />
                </Box>
                <FormControl
                  sx={{ width: "100%" }}
                  variant="standard"
                  disabled={
                    activeUserCheck == undefined|| billingStatmentLoading == true || filter?.userId === ""
                  } // Conditionally disable the FormControl
                >
                  <Autocomplete
                    sx={{
                      width: "100%",
                      fontSize: "14px !important",
                      // "& .MuiAutocomplete-inputRoot": {
                      //   paddingRight: "10px !important",
                      // },
                      "& .MuiAutocomplete-input": {
                        color: "#212121 !important",
                        fontSize: "14px !important",
                        // height: '25px !important'
                      },
                    }}
                    options={projectList || []}
                    getOptionLabel={(option) => option.Name || ""}
                     value={
                   activeUserCheck
                     ? (Array.isArray(projectList)
                        ? projectList.find(
                       (project) => project.ProjectId === filter?.projectId
                      ) || null
                       : null)
                      : null
                    }
                    onChange={handleFilterChange1}
                    inputValue={inputValue1}
                    onInputChange={(event, newInputValue) =>
                      setInputValue1(newInputValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search Project"
                        sx={{
                          height: "25px !imporatant",
                          color: "#212121 !important",
                          fontSize: "14px !important",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {/* {billingStatementLoading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null} */}
                              {params.InputProps.endAdornment}
                              {activeUserCheck && projectList.find(
                        (project) => project.ProjectId === filter?.projectId) && filter.projectId && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => {
                                      // Reset projectId when remove button is clicked
                                      setFilter((prevState) => ({
                                        ...prevState,
                                        projectId: "",
                                        filterValues: {},
                                      }));
                                      dispatch({
                                        type: types.BILLING_STATEMENT_SELECT,
                                        payload: {
                                          ...filter,
                                          projectId: "",
                                          filterValues: {},
                                        },
                                      });
                                    }}
                                  >
                                    <HighlightOffIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              )}
                            </>
                          ),
                        }}
                      />
                    )}
                    noOptionsText="No projects found"
                    clearOnEscape
                    disabled={billingStatmentLoading}
                    renderOption={(props, option) => (
                      <li
                        style={{
                          color: "#212121 !important",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                        {...props}
                        key={option.ProjectId}
                      >
                        {option.Name}
                      </li>
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.ProjectId === value.ProjectId
                    }
                    // filterOptions={(options, state) => {
                    //   return options
                    //     .filter((item) => {
                    //       if (filter?.projectStatus === true) {
                    //         return item?.Active === 1;
                    //       } else if (filter?.projectStatus === false) {
                    //         return item?.Active === 0;
                    //       } else if (filter?.projectStatus === "") {
                    //         return true; // Show all values
                    //       }
                    //       return false; // Default case (if needed)
                    //     })
                    //     .sort((a, b) => {
                    //       const nameA = a.Name;
                    //       const nameB = b.Name;
                    //       const firstCharA = nameA[0].toLowerCase();
                    //       const firstCharB = nameB[0].toLowerCase();
                    //       if (firstCharA !== firstCharB) {
                    //         return firstCharA.localeCompare(firstCharB);
                    //       }
                    //       const isUpperCaseA =
                    //         nameA[0] === nameA[0].toUpperCase();
                    //       const isUpperCaseB =
                    //         nameB[0] === nameB[0].toUpperCase();
                    //       if (isUpperCaseA !== isUpperCaseB) {
                    //         return isUpperCaseA ? -1 : 1;
                    //       }
                    //       return nameA.localeCompare(nameB);
                    //     });
                    // }}
                    disableClearable
                    // clearOnEscape
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Display Billing Periods */}
          {billingStatmentLoading ? (
            <Box
              sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
              className="secound-bg-box user-log"
            >
              <Grid container>
                <Grid xs={12} md={12} colSpan={7} align="center">
                  <CircularProgress disableShrink />
                </Grid>
              </Grid>
            </Box>
          ) : activeUserCheck && isBillingStatementSearch ? (
            <Box
              sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
              className="secound-bg-box user-log"
            >
              <Grid container>
                <Grid xs={12} md={12}>
                  {/* Actions */}

                  <Stack
                    sx={{ float: "left", mt: "10px" }}
                    direction="row"
                    spacing={1}
                    alignItems="left"
                  >
                    <p style={{ mb: "0px" }} className="label oh-label">
                      Selected Project has {billPeriod} days Billing Period
                    </p>
                  </Stack>

                  <Stack
                    sx={{
                      float: { xs: "left", md: "right" },
                      alignItems: { xs: "flex-start", md: "center" },
                      marginTop: "0px",
                      marginBottom: "10px",
                    }}
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1}
                  >
                    {((billingfilter?.billingStartDate ||
                      billingfilter?.billingEndDate ||
                      billingfilter?.invoiceStatus ||
                      billingfilter?.broker?.length > 0) &&
                      applyFilterFlag) ||
                    billingfilter?.billingStartDate ||
                    billingfilter?.billingEndDate ||
                    billingfilter?.invoiceStatus ||
                    billingfilter?.broker?.length > 0 ? (
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">close</span>
                        }
                        className="clear-btn"
                        variant="contained"
                        onClick={clearBillingFilterFunc}
                      >
                        Clear Filter
                      </Button>
                    ) : (
                      ""
                    )}

                    {/* Filter Button */}
                    <Stack
                      className="filter"
                      sx={{ float: "right" }}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      onClick={filterOpenFun}
                    >
                      <span class="material-symbols-outlined">filter_list</span>
                      <Typography>Filter</Typography>
                    </Stack>
                  </Stack>

                  {/* Billing Periods Table */}
                  <TableContainer
                    className="billing-table"
                    sx={{ boxShadow: "none", maxHeight: 315 }}
                    component={Paper}
                  >
                    <Table
                      sx={{ minWidth: 650 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Billing Period</TableCell>
                          {/* <TableCell>Broker Name</TableCell> */}

                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "hours"}
                              direction={
                                billingStateOrderBy === "hours"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("hours")}
                              IconComponent={() => getLocationSortIcon("hours")}
                              style={
                                billingStateOrderBy === "hours"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Hours
                            </TableSortLabel>
                          </TableCell>

                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "dayRate"}
                              direction={
                                billingStateOrderBy === "dayRate"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("dayRate")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("dayRate")
                              }
                              style={
                                billingStateOrderBy === "dayRate"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Day Rate
                            </TableSortLabel>
                          </TableCell>

                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "miles"}
                              direction={
                                billingStateOrderBy === "miles"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("miles")}
                              IconComponent={() => getLocationSortIcon("miles")}
                              style={
                                billingStateOrderBy === "miles"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Miles
                            </TableSortLabel>
                          </TableCell>

                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "mileageRate"}
                              direction={
                                billingStateOrderBy === "mileageRate"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("mileageRate")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("mileageRate")
                              }
                              style={
                                billingStateOrderBy === "mileageRate"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Mileage Rate
                            </TableSortLabel>
                          </TableCell>

                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "perDiem"}
                              direction={
                                billingStateOrderBy === "perDiem"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("perDiem")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("perDiem")
                              }
                              style={
                                billingStateOrderBy === "perDiem"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Per Diem
                            </TableSortLabel>
                          </TableCell>

                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "statusId"}
                              direction={
                                billingStateOrderBy === "statusId"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("statusId")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("statusId")
                              }
                              style={
                                billingStateOrderBy === "statusId"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Status
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {loading ? (
                        <TableRow>
                          <TableCell colSpan={7} align="center">
                            <CircularProgress disableShrink />
                          </TableCell>
                        </TableRow>
                      ) : (
                        <TableBody>
                          {sortedLocationList.map((period, index) => {
                            console.log(period, "periodddddddd");
                            const currentDate = new Date();
                            const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed, so +1 is necessary
                            const currentYear = currentDate.getFullYear();

                            console.log(
                              currentYear,
                              "Current Month:",
                              currentMonth
                            ); // e.g., 10 for October
                            return (
                              <TableRow
                                key={index}
                                onClick={() => billingMoveClick(period)}
                              >
                                <TableCell>
                                  <span
                                    // className={
                                    //   currentMonthNumber > period.currentMonth &&
                                    //   period.statusId === 1
                                    //     ? "billing-list-current-month" : ""
                                    // }

                                    className={
                                      (currentYear > period.currentYear ||
                                        (currentYear === period.currentYear &&
                                          currentMonthNumber >
                                            period.currentMonth)) &&
                                      period.statusId === 1
                                        ? "ribbon-box"
                                        : currentYear === period.currentYear &&
                                          currentMonthNumber ===
                                            period.currentMonth &&
                                          period.statusId === 1
                                        ? "ribbon-box-active"
                                        : ""
                                    }
                                  >
                                    {/* {moment
                                      .utc(`${period.BillingStart}`)
                                      .format("MM/DD/YYYY")}
                                    {" - "}
                                    {moment
                                      .utc(`${period.BillingEnd}`)
                                      .format("MM/DD/YYYY")} */}
                                    {period.billingDateListNew}
                                  </span>
                                </TableCell>
                                {/* <TableCell>{period.brokerName}</TableCell> */}
                                <TableCell>
                                  {period.hours
                                    ? period.hours.toFixed(2)
                                    : (0).toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  $
                                  {period.dayRate
                                    ? period.dayRate.toFixed(2)
                                    : (0).toFixed(2)}
                                </TableCell>
                                <TableCell>
                                  {period.miles}
                                  {/* {period.miles ? period.miles : 0} */}
                                </TableCell>
                                <TableCell>
                                  ${period.mileageRate}
                                  {/* {period.mileageRate
                                  ? period.mileageRate.toFixed(2)
                                  : (0).toFixed(2)} */}
                                </TableCell>
                                <TableCell>
                                  ${period.perDiem}
                                  {/* {period.perDiem
                                  ? period.perDiem.toFixed(2)
                                  : (0).toFixed(2)} */}
                                </TableCell>
                                <TableCell>
                                  {period.statusId === 1 && (
                                    <span className="active-btn">
                                      Statement Open
                                    </span>
                                  )}
                                  {period.statusId === 2 && (
                                    <span className="closed-btn">
                                      Statement Closed
                                    </span>
                                  )}
                                  {period.statusId === 3 && (
                                    <span className="started-btn">
                                      Invoice Started
                                    </span>
                                  )}
                                  {period.statusId === 4 && (
                                    <span className="active-btn">
                                      Invoice Closed
                                    </span>
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      )}
                    </Table>
                    {/* <br />
                    {!loading && total > 0 && (
                      <Pagination
                        shape="rounded"
                        renderItem={(item) => (
                          <PaginationItem
                            components={{
                              previous: () => (
                                <Icon className="material-symbols-outlined">
                                  keyboard_backspace
                                </Icon>
                              ),
                              next: () => (
                                <Icon className="material-symbols-outlined">
                                  east
                                </Icon>
                              ),
                            }}
                            {...item}
                          />
                        )}
                        count={total}
                        page={page}
                        onChange={handlePageChange}
                      />
                    )} */}
                  </TableContainer>
                  {!loading && periods && periods.length == 0 ? (
                    <NoRecordFound />
                  ) : (
                    <></>
                  )}
                  {/* Create Billing Confirm Dialog */}
                  {open && (
                    <CreateBillingConfirm
                      open={open}
                      createBilling={createBilling}
                    />
                  )}

                  {/* Billing Statement Filter */}
                  {openFilter && (
                    <BillingStatementFilter
                      open={openFilter}
                      handleClose={filterClose}
                      filter={billingfilter}
                      setFilter={setBillingFilter}
                      setApplyFilterFlag={setApplyFilterFlag}
                      filterInitial={billingFilterInitial}
                      submitFilter={submitFilter}
                      billPeriod={billPeriod}
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          ) : (
            !billingStatmentLoading && (
              <Box className="secound-bg-box user-log">
                <Grid container>
                  <Box
                    sx={{
                      textAlign: "center",
                      width: "100%",
                      background: "#fff",
                      marginTop: "15px",
                      borderRadius: "5px",
                    }}
                  >
                    <img
                      style={{ width: "100%", maxWidth: "326px" }}
                      src={BillingNodata}
                    />
                    <p
                      style={{ marginTop: "15px", marginBottom: "50px" }}
                      className="no-data-text"
                    >
                      Please select a{" "}
                      <span style={{ color: "#58A84A" }}>customer</span> and{" "}
                      <span style={{ color: "#58A84A" }}>project</span> to view
                      the billing statements.
                    </p>
                  </Box>
                </Grid>
              </Box>
            )
          )}
          {billingHelpButton ? (
            <BillingInfoModel
              open={billingHelpButton}
              setBillingHelpButton={setBillingHelpButton}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
};

export default BillingList;
